"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsEngine = void 0;
const viewer_settings_1 = require("@shapediver/viewer.settings");
const tsyringe_1 = require("tsyringe");
const EventEngine_1 = require("../event-engine/EventEngine");
const Logger_1 = require("../logger/Logger");
const ShapeDiverViewerErrors_1 = require("../logger/ShapeDiverViewerErrors");
let SettingsEngine = class SettingsEngine {
    constructor() {
        // #region Properties (8)
        this._eventEngine = tsyringe_1.container.resolve(EventEngine_1.EventEngine);
        this._logger = tsyringe_1.container.resolve(Logger_1.Logger);
        this._settings = viewer_settings_1.DefaultsV3_1();
        this._settings_version = '3.1';
        // #endregion Private Methods (1)
    }
    // #endregion Properties (8)
    // #region Public Accessors (10)
    get ar() {
        return this._settings.ar;
    }
    get camera() {
        return this._settings.camera;
    }
    get environment() {
        return this._settings.environment;
    }
    get environmentGeometry() {
        return this._settings.environmentGeometry;
    }
    get general() {
        return this._settings.general;
    }
    get light() {
        return this._settings.light;
    }
    get rendering() {
        return this._settings.rendering;
    }
    get session() {
        return this._settings.session;
    }
    set session(value) {
        this._settings.session = value;
    }
    get settings() {
        return this._settings;
    }
    // #endregion Public Accessors (10)
    // #region Public Methods (4)
    convertToTargetVersion() {
        return viewer_settings_1.convert(this._settings, this._settings_version);
    }
    flatten() {
        const flattenObject = (ob) => {
            const toReturn = {};
            for (let i in ob) {
                if (!ob.hasOwnProperty(i))
                    continue;
                if ((typeof ob[i]) == 'object') {
                    const flatObject = flattenObject(ob[i]);
                    for (var x in flatObject) {
                        if (!flatObject.hasOwnProperty(x))
                            continue;
                        toReturn[i + '.' + x] = flatObject[x];
                    }
                }
                else {
                    toReturn[i] = ob[i];
                }
            }
            return toReturn;
        };
        return flattenObject(this.settings);
    }
    loadSettings(json, sessionId, loadAsPrimary = false) {
        if (JSON.stringify(json) !== JSON.stringify({})) {
            try {
                viewer_settings_1.validate(json, '1.0');
                this._settings_version = '1.0';
                this._settings = viewer_settings_1.convert(json, '3.1');
                this.cleanSettings(this._settings);
                return;
            }
            catch (e) { }
            try {
                viewer_settings_1.validate(json, '2.0');
                this._settings_version = '2.0';
                this._settings = viewer_settings_1.convert(json, '3.1');
                this.cleanSettings(this._settings);
                return;
            }
            catch (e) { }
            try {
                viewer_settings_1.validate(json, '3.0');
                this._settings_version = '3.0';
                this._settings = viewer_settings_1.convert(json, '3.1');
                this.cleanSettings(this._settings);
                return;
            }
            catch (e) { }
            try {
                viewer_settings_1.validate(json, '3.1');
                this._settings_version = '3.1';
                this._settings = viewer_settings_1.convert(json, '3.1');
                this.cleanSettings(this._settings);
                return;
            }
            catch (e) {
                const error = new ShapeDiverViewerErrors_1.ShapeDiverViewerSettingsError('SettingsEngine.loadSettings: Settings could not be validated.', e);
                throw this._logger.handleError(Logger_1.LOGGINGTOPIC.SETTINGS, `SettingsEngine.loadSettings`, error);
            }
        }
        else {
            this._settings_version = '3.1';
            this._settings = viewer_settings_1.DefaultsV3_1();
            return;
        }
    }
    reset() {
        this._settings_version = '3.1';
        this._settings = viewer_settings_1.DefaultsV3_1();
    }
    // #endregion Public Methods (4)
    // #region Private Methods (1)
    cleanSettings(json) {
        for (let c in json.camera.cameras) {
            const camera = json.camera.cameras[c];
            if (camera.type === 'perspective') {
                const restrictions = camera.controls.restrictions;
                if (restrictions.position.cube.min.x === null)
                    restrictions.position.cube.min.x = -Infinity;
                if (restrictions.position.cube.min.y === null)
                    restrictions.position.cube.min.y = -Infinity;
                if (restrictions.position.cube.min.z === null)
                    restrictions.position.cube.min.z = -Infinity;
                if (restrictions.position.cube.max.x === null)
                    restrictions.position.cube.max.x = Infinity;
                if (restrictions.position.cube.max.y === null)
                    restrictions.position.cube.max.y = Infinity;
                if (restrictions.position.cube.max.z === null)
                    restrictions.position.cube.max.z = Infinity;
                if (restrictions.position.sphere.radius === null)
                    restrictions.position.sphere.radius = Infinity;
                if (restrictions.target.cube.min.x === null)
                    restrictions.target.cube.min.x = -Infinity;
                if (restrictions.target.cube.min.y === null)
                    restrictions.target.cube.min.y = -Infinity;
                if (restrictions.target.cube.min.z === null)
                    restrictions.target.cube.min.z = -Infinity;
                if (restrictions.target.cube.max.x === null)
                    restrictions.target.cube.max.x = Infinity;
                if (restrictions.target.cube.max.y === null)
                    restrictions.target.cube.max.y = Infinity;
                if (restrictions.target.cube.max.z === null)
                    restrictions.target.cube.max.z = Infinity;
                if (restrictions.target.sphere.radius === null)
                    restrictions.target.sphere.radius = Infinity;
                if (restrictions.rotation.minAzimuthAngle === null)
                    restrictions.rotation.minAzimuthAngle = -Infinity;
                if (restrictions.rotation.maxAzimuthAngle === null)
                    restrictions.rotation.maxAzimuthAngle = Infinity;
                if (restrictions.zoom.maxDistance === null)
                    restrictions.zoom.maxDistance = Infinity;
            }
        }
    }
};
SettingsEngine = __decorate([
    tsyringe_1.singleton()
], SettingsEngine);
exports.SettingsEngine = SettingsEngine;
//# sourceMappingURL=SettingsEngine.js.map